type Props = {
  width?: string;
  height?: string;
  viewBox?: string;
  strokeColor?: string;
};

export default function GridIcon({
  width = '18',
  height = '18',
  viewBox = '0 0 18 18',
  strokeColor = '#F2D093',
}: Props) {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Outer rectangle */}
      <rect
        x="2"
        y="2"
        width="14"
        height="14"
        rx="0.5"
        stroke={strokeColor}
        strokeWidth="1"
      />
      {/* Horizontal dividing line */}
      <line x1="2" y1="9" x2="16" y2="9" stroke={strokeColor} strokeWidth="1" />
      {/* Vertical dividing line (bottom section only, offset left) */}
      <line x1="7" y1="9" x2="7" y2="16" stroke={strokeColor} strokeWidth="1" />
    </svg>
  );
}
